import {
    get,
    NetworkState,
    networkStateReducer, post,
} from "../networkStateReducer";
import {components, operations} from "../../__generated/api";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../index";
import {Address, ProfileRes} from "./get";
import {ConsumerProfileReq} from "./updateBillingAddress";

export const domain = "@appigo-retailer/profile/update"

export const profileUpdateShippingAddressReducer = networkStateReducer<ConsumerProfileReq>(domain)

export function useProfileUpdateShippingAddress(): [NetworkState<ProfileRes>, (address: Address) => void] {
    let dispatch = useDispatch();

    return [
        useSelector<RootState, NetworkState<ProfileRes>>(state => state.profile.updateShippingAddress),
        (address) => dispatch(post(domain, "/customer-api/v2/profile/update/shipping-address", address))
    ];

}
